import React from 'react';
import { Check, Lock } from 'lucide-react';
import { milestoneStates, fmtDate } from './fabDashUtils';

const DOT = {
  done: 'bg-blue-700 border-blue-700 text-white',
  current: 'bg-white border-emerald-500 ring-4 ring-emerald-100',
  blocked: 'bg-amber-100 border-amber-500 text-amber-700',
  todo: 'bg-white border-slate-300',
};

// Compact stepper: 8 dots joined by a line; labels under each on wide screens, hover title everywhere.
export const MilestoneTrack = ({ p, showDates = false }) => {
  if (!p.on_board) return <p className="text-xs text-slate-500 italic">Not on the Fab Scheduler — hours only</p>;
  const steps = milestoneStates(p);
  return (
    <ol className="flex items-start w-full" data-testid={`milestones-${p.id}`}>
      {steps.map((s, i) => (
        <li key={s.key} className="flex-1 min-w-0 flex flex-col items-center relative" title={`${s.label} — ${s.state}`}>
          {i > 0 && <span className={`absolute top-[9px] right-1/2 w-full h-0.5 -z-0 ${steps[i - 1].state === 'done' ? 'bg-blue-700' : 'bg-slate-200'}`} />}
          <span className={`relative z-10 w-[18px] h-[18px] rounded-full border-2 flex items-center justify-center ${DOT[s.state]}`}>
            {s.state === 'done' && <Check className="w-3 h-3" strokeWidth={3} />}
            {s.state === 'blocked' && <Lock className="w-2.5 h-2.5" />}
          </span>
          <span className={`mt-1 text-[10px] leading-tight text-center truncate w-full hidden sm:block ${s.state === 'current' ? 'text-emerald-700 font-semibold' : s.state === 'blocked' ? 'text-amber-700 font-semibold' : s.state === 'done' ? 'text-slate-700' : 'text-slate-500'}`}>
            {s.label}
          </span>
          {showDates && s.date && <span className="text-[10px] text-slate-500">{fmtDate(s.date)}</span>}
        </li>
      ))}
    </ol>
  );
};
